import React, { useState } from "react";
import "../styles/ContacUs.css";
import { MdOutlineWhereToVote, MdSmartphone, MdLocalPostOffice } from "react-icons/md";
import { FaPaperPlane } from "react-icons/fa";
import axios from "axios";
import urlBackEnd from "../services/authServices";
import { Button, Modal } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

var qs = require("qs");

function ContacUS() {
  const [contacData, setContacData] = useState({
    contacName: "",
    contacPhone: "",
    contacMail: "",
    contacBy: "",
    message: "",
  });
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [contacNameError, setContacNameError] = useState("");
  const [showConfirmModal, setConfirmModal] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const closeConfirModal = () => setConfirmModal(false);
  const handleChange = (e) => {
    setContacData({
      ...contacData,
      [e.target.name]: e.target.value,
    });
  };
  
  const handleRecaptchaChange = (value) => {
    setIsVerified(true);
  };

  const handleValidation = () => {
    let formIsValid = true;

    if (!contacData.contacName.match(/^[A-Za-zñÑ\s]+$/)) {
      formIsValid = false;
      setContacNameError("El nombre solo debe contener letras y espacios");
    } else {
      setContacNameError("");
    }

    if (!contacData.contacMail.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      formIsValid = false;
      setEmailError("Email no válido");
    } else {
      setEmailError("");
    }
    
    if (!contacData.contacPhone.match(/^\d{10,11}$/)) {
      formIsValid = false;
      setPhoneError("Ingrese un número de teléfono válido (10 dígitos)");
    } else {
      setPhoneError("");
    }

    if (!isVerified) {
      formIsValid = false;
      alert("Por favor complete desafío reCAPTCHA.");
    }

    return formIsValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(true); // Abre el modal de confirmación
  };

  const handleModalSubmit = () => {
    if (!handleValidation()) return;

    let config = {
      method: "POST",
      url: urlBackEnd.contacUrl,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(contacData)
    };

    axios(config)
      .then((response) => {
        const contacResponse = response.data;

        if (contacResponse.success) {
          alert("Solicitud de Contacto Enviado");
          window.location.reload();
        } else {
          alert("Solicitud de Contacto No Enviada. Por favor, vuelve a intentarlo.");
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Error de Conexión");
      });
  };

  return (
    <div className="w3-card w3-container w3-content w3-padding-64 w3-section" id="contact">
      <h2 className="w3-wide w3-center">CONTACTAME</h2>
      <p className="w3-opacity w3-center">
        <b>Quiero Saber más Acerca de los productos y servicios que ofreces!</b>
      </p>
      <div className="w3-row w3-padding-32">
        <div className="w3-col m6 w3-large w3-margin-bottom">
          <MdOutlineWhereToVote style={{ width: "30px" }} />
          Barranquilla, Atlantico
          <br />
          <MdSmartphone style={{ width: "30px" }} /> Phone: +57 3015442800
          <br />
          <MdLocalPostOffice style={{ width: "30px" }}> </MdLocalPostOffice>{" "}
          Email: nicolasmuoz@gmail.com
          <br />
        </div>
        <div className="w3-col m6">
          <form onSubmit={handleSubmit}>
            <div className="w3-row-padding">
              <div>
                <input
                  className={`w3-input w3-border ${contacNameError ? "is-invalid" : ""}`}
                  type="text"
                  placeholder="Nombre Completo"
                  required
                  name="contacName"
                  value={contacData.contacName}
                  onChange={handleChange}
                />
                <small className="text-danger form-text">{contacNameError}</small>
              </div>
              <div>
                <input
                  className={`w3-input w3-border ${phoneError ? "is-invalid" : ""}`}
                  type="number"
                  placeholder="Celular"
                  required
                  name="contacPhone"
                  value={contacData.contacPhone}
                  onChange={handleChange}
                />
                <small className="text-danger form-text">{phoneError}</small>
              </div>
              <div>
                <input
                  className={`w3-input w3-border ${emailError ? "is-invalid" : ""}`}
                  type="text"
                  placeholder="Email"
                  required
                  name="contacMail"
                  value={contacData.contacMail}
                  onChange={handleChange}
                />
                <small className="text-danger form-text">{emailError}</small>
              </div>
              <div>
                <select
                  className="w3-input w3-border"
                  required
                  name="contacBy"
                  onChange={handleChange}
                  value={contacData.contacBy}
                >
                  <option disabled value="">
                    Estás Interesado en:
                  </option>
                  <option value="Webdev">Diseño y Desarrollo Web</option>
                  <option value="Iot">Domótica y IoT</option>
                  <option value="Network">Networking</option>
                  <option value="Support">Soporte técnico</option>
                  <option value="CCTV">Seguridad Electrónica, CCTV</option>
                </select>
              </div>
              <div>
                <textarea
                  className="w3-input w3-border"
                  placeholder="Escriba un mensaje corto"
                  name="message"
                  onChange={handleChange}
                  value={contacData.message}
                ></textarea>
              </div>
            </div>
            <Button className="w3-button w3-black w3-section w3-right" type="submit">
              Enviar
            </Button>
          </form>
        </div>
      </div>
      <Modal show={showConfirmModal} onHide={closeConfirModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Validación para Enviar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReCAPTCHA
            sitekey="6LfejS4oAAAAANPW_qXxoFtx6NkXsEaRWgPnD6B3"
            onChange={handleRecaptchaChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleModalSubmit} disabled={!isVerified}>
            Enviar <FaPaperPlane />
          </Button>
          <Button variant="secondary" onClick={closeConfirModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ContacUS;
